var React = require('react');

function Binoculars60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M60 40c0 6.617-5.383 12-12 12-6.616 0-11.997-5.381-12-11.996V30.003c0-.552-.45-1.001-1.003-1.001h-9.994c-.553 0-1.003.449-1.003 1.001v10.001C23.998 46.619 18.616 52 12 52 5.383 52 0 46.617 0 40c0-.936.118-1.844.322-2.718.002-.016-.003-.031-.001-.046L6.017 6.688c.003-.018.015-.03.019-.047s-.001-.033.004-.05c1.132-3.88 4.748-6.592 8.796-6.592 4.98 0 9.037 3.996 9.153 8.949.001.019.011.035.011.054v6h12V9.164C36 4.111 40.111 0 45.164 0c4.048 0 7.665 2.711 8.796 6.594.005.015 0 .03.004.046.004.017.016.03.019.048l5.696 30.548c.003.016-.003.03-.001.046.204.875.322 1.782.322 2.718zM12 50c5.514 0 10-4.487 10-10 0-5.514-4.486-10.001-10-10.001S2 34.486 2 40c0 5.513 4.486 10 10 10zM52.031 7.13C51.139 4.108 48.319 2 45.164 2A7.172 7.172 0 0 0 38 9.164v6.839a.998.998 0 0 1-1 .999H23c-.553 0-1-.446-1-.999V9.164c0-3.951-3.214-7.165-7.164-7.165A7.196 7.196 0 0 0 7.97 7.125L3.398 31.651A11.956 11.956 0 0 1 12 28c4.172 0 7.849 2.141 10 5.38v-3.377a3.005 3.005 0 0 1 3.003-3.001h9.994A3.005 3.005 0 0 1 38 30.003v3.377C40.151 30.141 43.828 28 48 28c3.373 0 6.42 1.403 8.602 3.651L52.031 7.13zM48 29.999c-5.514 0-10 4.487-10 10.001 0 5.513 4.486 10 10 10s10-4.487 10-10c0-5.514-4.486-10.001-10-10.001z","key":1})]);
}

Binoculars60px.displayName = "Binoculars60px";

Binoculars60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 52"};

module.exports = Binoculars60px;

Binoculars60px.default = Binoculars60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/binoculars-60px.svg
// module id = 1183
// module chunks = 0